import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import React from 'react';
import EllipsisText from '../components/EllipsisText';
import { Icons } from '../icons/Icons';
import { FormModalHeaderProps } from './formUtils';

export default function FormModalHeader({ title, onClose, sx }: FormModalHeaderProps) {
    return (
        <Box
            className="form-modal-header handle"
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                px: 2.5,
                py: 2,
                flexGrow: 0,
                borderBottom: 1,
                borderColor: 'divider',
                color: 'text.primary',
                ...sx
            }}
        >
            {title ? (
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexGrow: 2 }}>
                    <EllipsisText sx={{ fontSize: 'large', textTransform: 'none' }} text={title} />
                </Box>
            ) : (
                <></>
            )}
            {typeof onClose === 'function' ? (
                <Box sx={{ flexGrow: 2, textAlign: 'end' }}>
                    <IconButton size="small" color="inherit" onClick={onClose}>
                        <Icons.Close />
                    </IconButton>
                </Box>
            ) : (
                <></>
            )}
        </Box>
    );
}
